import { Entities } from '@inwink/entities/entities';
import { Link } from 'react-router-dom';
import * as moment from 'moment';
import { React, AppAsyncButton, IPopoverManager, DisplayDate } from '@@commons';
import { i18NHelperContext } from '@@services/i18nservice';
import { ItemWebsite, IItemWebsiteProps } from './itemwebsite';

import './eventitem.less';

interface IEventItemProps {
    popovermgr: IPopoverManager;
    className?: string;
    popoverClassName?: string;
    eventitem: any;
    customerid: string;
    onRemove?: (eventitem: any) => any;
    style?: any;
    disableClick?: boolean;
    onClick?: (eventitem: any) => void;
    onAfterClick?: (eventitem: any) => void;
    children?: React.ReactNode;
}

export class EventItem extends React.Component<IEventItemProps, any> {
    removeItem: (arg: React.MouseEvent<any>) => any;

    constructor(props) {
        super(props);
        if (props.onRemove) {
            this.removeItem = (arg) => {
                arg.preventDefault();
                arg.stopPropagation();
                return this.props.onRemove(this.props.eventitem);
            };
        }
    }

    eventClicked = (arg: React.MouseEvent<any>) => {
        arg.preventDefault();
        arg.stopPropagation();
        this.props.onClick(this.props.eventitem);
    };

    afterClick = () => {
        if (this.props.onAfterClick) {
            this.props.onAfterClick(this.props.eventitem);
        }
    };

    openPreview = (arg: React.MouseEvent<any>) => {
        arg.preventDefault();
        arg.stopPropagation();
        const props: IItemWebsiteProps = {
            item: this.props.eventitem,
            itemType: 'event'            
        };
        this.props.popovermgr?.popoverPortal(arg.currentTarget, ItemWebsite,
            props, "itemwebsitepopover " + (this.props.popoverClassName || ""));
    };

    renderStats(i18n: Entities.i18nHelper) {
        if (this.props.eventitem.stat) {
            return <div className="eventstat">
                {this.props.eventitem.stat.invited
                    ? <span className="invited" title={i18n.translate("eventitem.invited")}>
                        <i className="inwink-logout" /> {this.props.eventitem.stat.invited}</span>
                    : null}
                {this.props.eventitem.stat.registered
                    ? <span className="registered" title={i18n.translate("eventitem.registered")}>
                        <i className="inwink-group" /> {this.props.eventitem.stat.registered}</span>
                    : null}
                {this.props.eventitem.stat.attended
                    ? <span className="attended" title={i18n.translate("eventitem.attended")}>
                        <i className="inwink-event" /> {this.props.eventitem.stat.attended}</span>
                    : null}
            </div>;
        }

        return null;
    }

    renderDates() {
        const event = this.props.eventitem;
        let startDate = event.startDate;
        if (!startDate) {
            startDate = (event.date ? event.date.start : null);
        }
        let endDate = event.endDate;
        if (!endDate) {
            endDate = (event.date ? event.date.end : null);
        }
        if (startDate && endDate) {
            if (moment(startDate).isSame(moment(endDate), 'day')) {
                return <div className="eventdate">
                    <DisplayDate format="L" date={startDate} />
                </div>;
            }

            return <div className="eventdate">
                <DisplayDate format="L" date={startDate} />
                <span className="sep accent-2">
                    <i className="inwink-arrow-right" />
                </span>
                <DisplayDate format="L" date={endDate} />
            </div>;
        }

        return null;
    }

    renderContent(i18n: Entities.i18nHelper) {
        const event = this.props.eventitem;
        const actionsItems = [];

        let actions = null;
        if (this.props.onRemove) {
            actionsItems.push(
                <AppAsyncButton key={actionsItems.length} onClick={this.removeItem}>
                    <i className="inwink-trash" />
                </AppAsyncButton>
            );
        }

        if (event.eventKey) {
            actionsItems.push(<AppAsyncButton
                key="openpreview"
                title="actions.openpreview"
                className="openpreview"
                onClick={this.openPreview}
            ><i className="inwink-web" /></AppAsyncButton>);
        }

        if (actionsItems.length) {
            actions = <div className="actions">{actionsItems}</div>;
        }

        return <>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 110.91 110.91">
                <defs>
                    <style>{`.white {fill: #fff;} .logo-event {fill: var(--orange);} .e {isolation: isolate; opacity: 0.9;`}</style>
                </defs>
                <g id="a"/>
                <g id="b">
                    <g id="c">
                    <path className="logo-event" d="M110.9,55.45c0,15.32,.51,33.15-10.89,44.59-11.4,11.44-29.25,10.86-44.56,10.86s-33.15,.51-44.59-10.89C-.58,88.62,0,70.77,0,55.45S-.5,22.3,10.9,10.86C22.3-.58,40.15,0,55.45,0s33.15-.5,44.59,10.9c11.44,11.4,10.86,29.25,10.86,44.55Z"/>
                        <g>
                            <path className="e" d="M54.48,84.02l16.38-28.38c2.34-4.06,.95-9.24-3.1-11.59-1.29-.75-2.76-1.14-4.25-1.14H30.75c-4.68,0-8.48,3.8-8.48,8.48,0,1.49,.39,2.95,1.14,4.24l16.38,28.38c2.34,4.06,7.53,5.45,11.59,3.11,1.29-.75,2.36-1.82,3.11-3.11Z"/>
                            <path className="white" d="M75.94,85.18l11.87-20.57c1.7-2.94,.69-6.7-2.25-8.4-.93-.54-1.99-.82-3.07-.82h-23.77c-3.4,0-6.14,2.77-6.13,6.17,0,1.07,.29,2.13,.82,3.06l11.88,20.57c1.7,2.94,5.47,3.95,8.41,2.24,.93-.54,1.71-1.31,2.24-2.24Z"/>
                            <circle className="e white" cx="47.13" cy="30.68" r="8.03"/>
                        </g>
                    </g>
                </g>
            </svg>
            <div className="eventdetail">
                <div className="title">
                    <div className="eventname">
                        <div className="eventname-title">{event.title}</div>
                    </div>
                    {event?.authTenant?.name ? <div className="tenantname">
                        <div className="tenantname-title">{event.authTenant.name}</div>
                    </div> : null}
                    {this.renderDates()}
                </div>
                {this.renderStats(i18n)}
            </div>
            {this.props.children ? <div className='childs'>{this.props.children}</div> : null}
            {actions}
        </>;
    }

    render() {
        const event = this.props.eventitem;

        if (this.props.disableClick) {
            return <div className={"event-item clickable " + (this.props.className || "")} style={this.props.style}>
                <i18NHelperContext.Consumer>
                    {(i18n) => this.renderContent(i18n)}
                </i18NHelperContext.Consumer>
            </div>;
        }

        if (this.props.onClick) {
            return <div
                className={"event-item clickable " + (this.props.className || "")}
                style={this.props.style}
                onClick={this.eventClicked}
            >
                <i18NHelperContext.Consumer>
                    {(i18n) => this.renderContent(i18n)}
                </i18NHelperContext.Consumer>
            </div>;
        }

        return <Link
            to={"/" + (event.customerId || this.props.customerid) + "/e/" + event.id}
            className={"event-item " + (this.props.className || "")}
            style={this.props.style}
            onClick={this.afterClick}
        >
            <i18NHelperContext.Consumer>
                {(i18n) => this.renderContent(i18n)}
            </i18NHelperContext.Consumer>
        </Link>;
    }
}
